import { Component } from '@angular/core';
import { ThemeService } from './core/services/theme.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.html',
})
export class App {
  /**
   * Apply the persisted appearance (theme + accent colour + font) immediately in
   * the constructor — before Angular renders a single component — so there is no
   * flash of the wrong appearance on startup or after a browser refresh.
   */
  constructor(themeService: ThemeService) {
    themeService.applyStoredAppearance();
  }
}
